import { SwitchProfileDTO } from "utils/helpers/models/auth/switch-profile.dto";
import { getRequest, patchRequest, postRequest } from "../../utils/helpers/common/http-methods";
import { LoginByGoogleDTO } from "utils/helpers/models/auth/login-by-google.dto";
import { LoginByAppleDTO } from "utils/helpers/models/auth/login-by-apple.dto";
import { UpgradeProfileDTO } from "utils/helpers/models/auth/upgrade-profile.dto";
import { DeviceTokenDTO } from "utils/helpers/models/auth/device-token.dto";

export const Auth_APIS = {
  login: (body: any) => postRequest("/login", body),
  businessRegister: (body: any) => postRequest("/register-host", body),
  verifyOtpSignup: (body: any) => postRequest("/verify", body),
  verifyOtpForget: (body: any) => postRequest("/verifyOtp", body),
  resendOtp: (body: any) => postRequest("/resend", body),
  resetPassword: (body: any) => postRequest("/reset", body),
  confirmPassword: (body: any) => postRequest("/verify", body),
  loginByGoogle: (body: LoginByGoogleDTO) => postRequest('api/auth/google-login', body),
  loginByApple: (body: LoginByAppleDTO) => postRequest('api/auth/apple-login', body),
  getUserProfile: () => getRequest('/user/profile'),
  uploadFile: (body: FormData) => postRequest("/file/upload", body),
  getStates: () => fetch('/states.json'),
  switchProfile: (body: SwitchProfileDTO) => postRequest('/auth/switch-role', body),
  setDefaultRole: (body: SwitchProfileDTO) => postRequest('/auth/set-default-role', body),
  upgradeProfie: (body: UpgradeProfileDTO) => postRequest('/auth/user-type-upgrade', body),
  storeDeviceToken: (body: DeviceTokenDTO) => postRequest('/device-tokens/store', body),
  getUserById: (userId: number) => getRequest(`auth/user/${userId}/details`),
  getNotification: (params?: { offset?: number; limit?: number }) => {
    const queryParams = new URLSearchParams();
    if (params?.offset !== undefined) queryParams.append('offset', params.offset.toString());
    if (params?.limit !== undefined) queryParams.append('limit', params.limit.toString());
    const queryString = queryParams.toString();
    return getRequest(`auth/notifications${queryString ? `?${queryString}` : ''}`);
  },
  markAllNotificationAsRead: () => patchRequest(`/notification/read/all`,{}),
  getNotificationCount: () => getRequest('/notifications/count'),
  markNotificationAsRead: (id: number) => patchRequest(`/notification/${id}/read`,{}),
  getPrivacyPolicy: (body:any) => getRequest('/privacy-policy',body),

};
